import { useContext } from 'react';
import styled from '@emotion/styled';
import { ModalContentContext } from 'src/context/ModalContext/ModalContentContext';
import { hexToRgb } from 'src/utils/common';
const Wrap = styled.div`
  position: absolute;
  top: 16px;
  ${({
  theme
}) => theme.isRtl ? 'left' : 'right'}: 16px;
  z-index: 1;
`;
const Back = styled.div`
  position: relative;
  width: 6px;
  height: 64px;
  background-color: ${({
  theme
}) => `rgba(${hexToRgb(theme.color.contentDeepFixed)}, 0.5)`};
  border-radius: 3px;
  box-shadow: ${({
  theme
}) => `0px 2px 4px rgba(${hexToRgb(theme.color.contentDeepFixed)}, 0.16)`};
`;
const Indicator = styled.div<{
  percent: number;
}>`
  position: absolute;
  top: ${({
  percent
}) => (64 - 24) * percent / 100}px;
  width: 100%;
  border-radius: 3px;
  height: 24px;
  background-color: ${({
  theme
}) => theme.color.contentBrightFixed};
`;
const ScrollIndicator = () => {
  const {
    scrollPercent
  } = useContext(ModalContentContext);
  return <Wrap data-sentry-element="Wrap" data-sentry-component="ScrollIndicator" data-sentry-source-file="ScrollIndicator.tsx">
      <Back data-sentry-element="Back" data-sentry-source-file="ScrollIndicator.tsx">
        <Indicator percent={scrollPercent} data-sentry-element="Indicator" data-sentry-source-file="ScrollIndicator.tsx" />
      </Back>
    </Wrap>;
};
export default ScrollIndicator;